import React from "react";
import {useInvestAssistantContext} from "./ContextType";
import {Box, Grid, Typography} from "@mui/material";
import LinearProgress, {linearProgressClasses} from "@mui/material/LinearProgress";
import {styled} from '@mui/material/styles';

const BorderLinearProgress = styled(LinearProgress)(({theme}) => ({
    height: 10,
    width: '100%',
    borderRadius: 10,
    border: '0',
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: '#ffffff',
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 10,
    },
}));

export function ProgressInfoBox() {

    const {currentStageNumberToDisplay, numStages} = useInvestAssistantContext();

    const progressInPercent = (currentStageNumberToDisplay - 1) * Math.round(100 / (numStages - 1));

    return (
        <>
            <Grid container justifyContent="center" paddingBottom={7}>
                <Box sx={{display: 'flex', alignItems: 'center', width: '100%'}}>
                    <Box sx={{width: '100%', mr: 1}}>
                        <BorderLinearProgress variant="determinate" value={progressInPercent}/>
                    </Box>
                    <Box sx={{minWidth: 35}}>
                        <Typography variant="body2" color="text.secondary" align={"right"} style={{margin: 0}}>{`${Math.round(
                            progressInPercent,
                        )}%`}</Typography>
                    </Box>
                </Box>
            </Grid>
        </>
    );
}
